import { render, staticRenderFns } from "./dynamic-form.vue?vue&type=template&id=847dae8c&scoped=true&"
import script from "./dynamic-form.vue?vue&type=script&lang=js&"
export * from "./dynamic-form.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-form.vue?vue&type=style&index=0&id=847dae8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847dae8c",
  null
  
)

export default component.exports